import React, {PureComponent, Fragment} from "react"
import {StatementItem as StatementItemType} from "@irati/types"

import {injectIntl, InjectIntl, FormattedMessage} from "@irati/utils/lang"
import walletService from "@irati/wallet/graph/wallet"
import Loading from "@irati/ui/src/Loading"
import {hangPromise} from "@irati/utils/promise"
import groupByDate from "@irati/wallet/helpers/groupWalletItemsByDate"
import Spacing from "@irati/ui/src/Spacing"

import {StatementItem, Hr, ShowMoreButton} from "../../StatementItems"
import DateHeader from "../../DateHeader"
import NoData from "../../NoData"

interface Props extends InjectIntl {
  walletId: string
}

interface State {
  initialLoad: Promise<any> | null,
  fetchMoreLoad: Promise<any> | null,
  results: StatementItemType[],
  cursor?: string
}

class RewardWalletTransactions extends PureComponent<Props, State> {
  state: State = {
    initialLoad: hangPromise(),
    fetchMoreLoad: null,
    results: []
  }

  componentDidMount() {
    const {walletId} = this.props
    const initialLoad = walletService.statementItems(walletId)
      .then(({results, cursor}) => this.setState({results, cursor}))
    this.setState({initialLoad})
  }

  handleFetchMore = () => {
    const {walletId} = this.props
    const {cursor} = this.state
    const fetchMoreLoad = walletService.statementItems(walletId, cursor)
      .then((data) => this.setState((prevState: State) => ({
        results: [...prevState.results, ...data.results],
        cursor: data.cursor
      })))
    this.setState({fetchMoreLoad})
  }

  render() {
    const {formatMessage} = this.props
    const {initialLoad, fetchMoreLoad, results, cursor} = this.state
    const groupedData = groupByDate([], results)

    return (
      <Spacing marginTop={4} id="statementItems_containerId">
        <Loading load={initialLoad}>
          {groupedData.results.map(({data, date}) => {
            const key = date.format("YYYY-MM-DD")
            return (
              <Fragment key={key}>
                <Hr />
                <DateHeader date={date} />
                {data.map((statementItem: StatementItemType) => (
                  <StatementItem
                    statementItem={statementItem}
                    key={statementItem.uuid} />
                ))}
              </Fragment>
            )
          })}
          {results.length
            ? <Loading load={fetchMoreLoad}>
              {cursor &&
                <ShowMoreButton onClick={this.handleFetchMore}>
                  <FormattedMessage
                    id="wallet.statementItems.rewardWallet.showMoreButton.text" />
                </ShowMoreButton>
              }
            </Loading>
            : <NoData useCardStyle text={formatMessage({id: "wallet.reward.noScheduledTransfers.text"})} />
          }
        </Loading>
      </Spacing>
    )
  }
}

export default injectIntl(RewardWalletTransactions)
